import React, { useEffect } from "react";
import "@/App.css";
import "@/i18n";
import { useTranslation } from "react-i18next";
// Self-host fonts so html-to-image can embed them in downloaded share-cards.
import "@fontsource/playfair-display/400.css";
import "@fontsource/playfair-display/600.css";
import "@fontsource/playfair-display/700.css";
import "@fontsource/playfair-display/400-italic.css";
import "@fontsource/cormorant-garamond/400.css";
import "@fontsource/cormorant-garamond/500.css";
import "@fontsource/cormorant-garamond/600.css";
import "@fontsource/cormorant-garamond/400-italic.css";
import "@fontsource/caveat/400.css";
import "@fontsource/caveat/500.css";
import "@fontsource/caveat/600.css";
import "@fontsource/caveat/700.css";
import "@fontsource/zcool-xiaowei";
import "@fontsource/noto-serif-tc/400.css";
import "@fontsource/noto-serif-tc/500.css";
import "@fontsource/noto-serif-tc/600.css";
import "@fontsource/noto-serif-sc/400.css";
import "@fontsource/noto-serif-sc/500.css";
import "@fontsource/noto-serif-sc/600.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import SuccessPage from "@/pages/SuccessPage";
import AdminPage from "@/pages/AdminPage";
import LegalPage from "@/pages/LegalPage";
import PreviewPage from "@/pages/PreviewPage";
import EchoPage from "@/pages/EchoPage";
import RescuePage from "@/pages/RescuePage";
import VipRedeemPage from "@/pages/VipRedeemPage";
import PressPage from "@/pages/PressPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  const { i18n } = useTranslation();

  // Keep <html lang="…"> in sync with the active locale on every route so
  // Googlebot (which renders JS) sees the correct language variant when it
  // hits /rescue, /success, /echo/:id, /privacy, /terms, etc. Also emits
  // hreflang parity signals for social crawlers.
  useEffect(() => {
    const apply = (lng) => {
      if (lng) document.documentElement.setAttribute("lang", lng);
    };
    apply(i18n.language);
    i18n.on("languageChanged", apply);
    return () => i18n.off("languageChanged", apply);
  }, [i18n]);

  // Expose the photographic wax substrate as a CSS custom property so the
  // `.wax-stamp` badges can reference `background-image: var(--wax-substrate)`.
  // Setting it here (rather than in CSS) sidesteps CRA's css-loader which
  // otherwise tries to resolve absolute `/…` URLs as JS modules.
  useEffect(() => {
    const base = process.env.PUBLIC_URL || "";
    document.documentElement.style.setProperty(
      "--wax-substrate",
      `url(${base}/press-kit/wax-blank-192.png)`
    );
    document.documentElement.style.setProperty(
      "--paper-letter",
      `url(${base}/press-kit/paper-letter.jpg)`
    );
    document.documentElement.style.setProperty(
      "--paper-envelope",
      `url(${base}/press-kit/paper-letter.jpg)`
    );
  }, []);

  return (
    <div className="App w-screen max-w-full overflow-x-hidden">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/preview" element={<PreviewPage />} />
          <Route path="/echo/:id" element={<EchoPage />} />
          <Route path="/rescue" element={<RescuePage />} />
          <Route path="/vip/:code" element={<VipRedeemPage />} />
          <Route path="/press" element={<PressPage />} />
          <Route path="/privacy" element={<LegalPage kind="privacy" />} />
          <Route path="/terms" element={<LegalPage kind="terms" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
